import ACTIONS from "../constants/actions";

const {
  DAILY_RATING_BACK_LOG_REQUEST,
  DAILY_RATING_BACK_LOG_SUCCESS,
  DAILY_RATING_BACK_LOG_FAIL,
  NOTIFICATION_ITEM_RATING,
  CLICK_ITEM_NOTIFICATION,
} = ACTIONS;

const initialState = {
  isLoading: false,
  data: {
    fromTime: "",
    toTime: "",
    notificationId: "",
    onBlur: false,
  },
  isClick: false,
};

const dailyRatingReducer = (state = initialState, action) => {
  switch (action.type) {
    case DAILY_RATING_BACK_LOG_REQUEST:
      return {
        isLoading: true,
        ...state,
      };
    case DAILY_RATING_BACK_LOG_SUCCESS:
      return {
        isLoading: false,
      };
    case DAILY_RATING_BACK_LOG_FAIL:
      return {
        isLoading: false,
        ...state,
      };
    case CLICK_ITEM_NOTIFICATION:
      return {
        ...state,
        data: {
          onBlur: action.payload.onBlur,
        },
      };
    case NOTIFICATION_ITEM_RATING:
      return {
        ...state,
        data: {
          fromTime: action.payload ? action.payload.fromTime : "",
          toTime: action.payload ? action.payload.toTime : "",
          notificationId: action.payload ? action.payload.notificationId : "",
        },
      };

    default:
      return state;
  }
};

export default dailyRatingReducer;
